var $3d7906abca323f27$exports = {};
$3d7906abca323f27$exports = {
    "colorFormat": `Kleuropmaak`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$3d7906abca323f27$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
